var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17753 1.25H8.75C9.7165 1.25 10.5 2.0335 10.5 3V10.25C10.5 11.2165 9.7165 12 8.75 12H1.75C0.783502 12 0 11.2165 0 10.25V3C0 2.0335 0.783502 1.25 1.75 1.25H2.32247C2.53761 0.527128 3.20724 0 4 0H6.5C7.29276 0 7.96239 0.527128 8.17753 1.25ZM2.41841 2.75H1.75C1.61193 2.75 1.5 2.86193 1.5 3V10.25C1.5 10.3881 1.61193 10.5 1.75 10.5H8.75C8.88807 10.5 9 10.3881 9 10.25V3C9 2.86193 8.88807 2.75 8.75 2.75H8.08159C7.80073 3.34124 7.1981 3.75 6.5 3.75H4C3.3019 3.75 2.69927 3.34124 2.41841 2.75ZM3.75 1.75C3.75 1.61193 3.86193 1.5 4 1.5H6.5C6.63807 1.5 6.75 1.61193 6.75 1.75V2C6.75 2.13807 6.63807 2.25 6.5 2.25H4C3.86193 2.25 3.75 2.13807 3.75 2V1.75Z",
    fill: "#5062F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardBlue);
export default __webpack_public_path__ + "static/media/clipboardBlue.b2d2327842d37f42d1f82e218a2a23e0.svg";
export { ForwardRef as ReactComponent };